import React from 'react';
import contact from './../../../images/contact.png';
import './ContactUs.css'
const ContactUs = () => {
    return (
        <div className='contact_img'>
            <div className='flex justify-end my-4'>
                <div data-aos="zoom-in-up" className='contact_form shadow-2xl'>
                    <h1 className='text-primary text-lg banner_text'>Contact us</h1>

                    <h1 className='text-black text-5xl font-bold banner_text leading-relaxed'>HAVE QUESTIONS? <br />
                        GET IN TOUCH!</h1>
                    <form>
                        <div className='flex-row justify-between sm:flex-col'>
                            <input className='inp border-b-2 border-primary' placeholder='name' type="text" />
                            <input className='inp  border-b-2 border-primary' placeholder='email' type="text" />
                        </div>
                        <div className='flex-row justify-between sm:flex-col mt-4'>
                            <input className='inp border-b-2 border-primary' placeholder='phone' type="text" />
                            <input className='inp  border-b-2 border-primary' placeholder='subject' type="text" />
                        </div>
                        <button className='mt-8 btn btn-primary rounded-none text-white'>Get In Touch</button>


                    </form>
                </div>
            </div>
        </div>

    );
};

export default ContactUs;